:host {
  /** @prop --button-background-color: Set the background color. */
  /** @prop --background-color: DEPRECATED: kept for backwards compatibility, but will be removed by August 2024 */
  --button-background-color: var(--background-color, var(--s-color-cta-default));

  /** @prop --button-background-color-primary: Set the primary background color. */
  /** @prop --background-color-primary: DEPRECATED: kept for backwards compatibility, but will be removed by August 2024 */
  --button-background-color-primary: var(--background-color-primary, var(--button-background-color));

  /** @prop --button-background-color-secondary: Set the secondary background color. */
  /** @prop --background-color-secondary: DEPRECATED: kept for backwards compatibility, but will be removed by August 2024 */
  --button-background-color-secondary: var(--background-color-secondary, transparent);

  /** @prop --button-background-color-tertiary: Set the tertiary background color. */
  /** @prop --background-color-tertiary: DEPRECATED: kept for backwards compatibility, but will be removed by August 2024 */
  --button-background-color-tertiary: var(--background-color-tertiary, transparent);

  /** @prop --button-background-color-hover: Set the background color on hover */
  --button-background-color-hover: var(--s-color-cta-hover);

  /** @prop --button-background-color-pressed: Set the background color on press */
  --button-background-color-pressed: var(--b-color-primary-darker);

  /** @prop --button-border-width: Set the border width of the <anchor-button> */
  /** @prop --border-width: DEPRECATED: kept for backwards compatibility, but will be removed by August 2024 */
  --button-border-width: var(--border-width, 0px);

  /** @prop --button-border-color: Set the border color of the <anchor-button> */
  --button-border-color: transparent;

  --button-outline: var(--s-color-outline-default);

  /** @prop --button-text-color: Set the text color. */
  /** @prop --text-color: DEPRECATED: kept for backwards compatibility, but will be removed by August 2024 */
  --button-text-color: var(--text-color, var(--c-color-text-button));

  /** @prop --button-icon-color: Set the icon color. */
  /** @prop --icon-color: DEPRECATED: kept for backwards compatibility, but will be removed by August 2024 */
  --button-icon-color: var(--icon-color, var(--s-color-icon-on-dark));

  /** @prop --button-line-height: Set the line height. */
  /** @prop --line-height: DEPRECATED: kept for backwards compatibility, but will be removed by August 2024 */
  --button-line-height: var(--line-height, var(--p-size-dynamic-300));

  /** @prop --button-top-left-radius: Set the top-left radius of the button. */
  --button-top-left-radius: var(--c-size-radius-button-top-left);

  /** @prop --button-top-right-radius: Set the top-right radius of the button. */
  --button-top-right-radius: var(--c-size-radius-button-top-right);

  /** @prop --button-bottom-left-radius: Set the bottom-left radius of the button. */
  --button-bottom-left-radius: var(--c-size-radius-button-bottom-left);

  /** @prop --button-bottom-right-radius: Set the bottom-right radius of the button. */
  --button-bottom-right-radius: var(--c-size-radius-button-bottom-right);

  /** @prop --button-gap-icon-text: Set the gap between icon and text. */
  /** @prop --gap-icon-text: DEPRECATED: kept for backwards compatibility, but will be removed by August 2024 */
  --button-gap-icon-text: var(--gap-icon-text, var(--p-size-static-100));

  /** @prop --button-width: Set the width. */
  /** @prop --width: DEPRECATED: kept for backwards compatibility, but will be removed by August 2024 */
  --button-width: var(--width, unset);

  display: block;

  width: var(--button-width);
}

.anchor-c-btn {
  $btn: &; // Storing 'anchor-c-btn' as variable called $btn to be used as a shorthand
  font-family: inherit;
  border-top-left-radius: var(--button-top-left-radius);
  border-top-right-radius: var(--button-top-right-radius);
  border-bottom-left-radius: var(--button-bottom-left-radius);
  border-bottom-right-radius: var(--button-bottom-right-radius);
  position: relative;
  cursor: pointer;
  vertical-align: middle;
  text-decoration: none;
  line-height: var(--button-line-height);
  font-size: var(--s-size-text-default);
  overflow: hidden;
  border: none;
  text-align: center;
  padding: var(--p-size-static-150) var(--p-size-static-200);
  display: inline-flex;
  justify-content: center;
  flex-direction: row;
  gap: var(--button-gap-icon-text);
  align-items: center;
  color: var(--button-text-color);
  width: var(--button-width);
  background-color: var(--button-background-color);

  &:hover {
    --button-background-color: var(--button-background-color-hover);
  }
  &:active {
    --button-background-color: var(--button-background-color-pressed);
  }
  &:focus-visible {
    outline: var(--button-outline) solid var(--s-size-outline-focus-ring-width);
    outline-offset: var(--s-size-outline-focus-ring-offset);
  }
  &__icon {
    position: relative;
  }
  &--primary {
    --button-background-color: var(--button-background-color-primary);
    &--on-dark {
      --button-background-color: var(--s-color-background-default-default);
      --button-text-color: var(--s-color-text-cta-default);
      --button-outline: var(--b-color-white);
      &:hover {
        --button-background-color: var(--p-color-stone-100);
        --button-text-color: var(--s-color-cta-hover);
        #{$btn}__icon {
          --button-icon-color: var(--s-color-icon-on-dark);
        }
      }
      &:active {
        --button-background-color: var(--p-color-stone-300);
        --button-text-color: var(--b-color-primary-darker);
      }
      #{$btn}__icon {
        --button-icon-color: var(--s-color-icon-variant);
      }
    }
  }
  &--secondary,
  &--secondary--on-dark {
    // Use calc to subtract the width of the border from the padding
    padding: calc(var(--p-size-static-150) - var(--button-border-width)) calc(var(--p-size-static-200) - var(--button-border-width));
    --button-background-color: var(--button-background-color-secondary);
    border: var(--button-border-width) solid var(--button-border-color);
    --button-border-width: var(--b-size-border-width-small);
    &:hover {
      --button-border-width: var(--b-size-border-width-medium);
      --button-background-color-hover: var(--button-background-color-secondary);
    }
    &:disabled, &[disabled] {
      --button-border-width: 0px;
    }
  }
  &--secondary {
    --button-text-color: var(--s-color-text-contrast);
    --button-border-color: var(--b-color-neutral-darker);
    &:hover {
      --button-text-color: var(--s-color-text-default);
      --button-border-color: var(--b-color-secondary);
      #{$btn}__icon {
        --button-icon-color: var(--s-color-icon-default);
      }
    }
    &:active {
      --button-background-color-pressed: var(--s-color-background-default-pressed);
    }
    #{$btn}__icon {
      --button-icon-color: var(--s-color-icon-default);
    }
    &--on-dark {
      --button-text-color: var(--color-text-on);
      --button-border-color: var(--s-color-border-on-dark);
      --button-outline: var(--b-color-white);
      &:active {
        --button-border-color: var(--b-color-neutral-default);
        --button-text-color: var(--b-color-neutral-default);
        --button-background-color-pressed: transparent;
      }
      #{$btn}__icon {
        --button-icon-color: var(--s-color-icon-on-dark);
      }
    }
  }
  &:disabled, &[disabled] {
    cursor: default;
    --button-text-color: var(--s-color-text-disabled);
    --button-background-color: var(--s-color-cta-disabled);
  }
  &--tertiary,
  &--tertiary--on-dark {
    --button-background-color: var(--button-background-color-tertiary);
    border-radius: 1px;
    border-bottom: var(--button-border-width) solid var(--button-border-color);
    --button-border-width: var(--b-size-border-width-medium);
    padding: var(--p-size-static-150) 0;
    padding-bottom: calc(var(--p-size-static-150) - var(--button-border-width));
    &:hover {
      text-decoration: none;
      --button-background-color-hover: var(--button-background-color-tertiary);
      --button-border-width: var(--b-size-border-width-large);
    }
    &:active {
      --button-background-color-pressed: var(--button-background-color-tertiary);
    }
    &:disabled, &[disabled] {
      --button-background-color: transparent;
    }
  }
  &--tertiary {
    --button-text-color: var(--s-color-text-contrast);
    --button-border-color: var(--b-color-neutral-darker);
    #{$btn}__icon {
      --button-icon-color: var(--b-color-neutral-darker);
    }
    &:hover {
      --button-text-color: var(--s-color-text-default);
      --button-border-color: var(--s-color-border-interaction);
      #{$btn}__icon {
        --button-icon-color: var(--b-color-neutral-darkest);
      }
    }
    &:active {
      --button-border-color: var(--b-color-black);
    }
    &:disabled, &[disabled] {
      --button-text-color: var(--p-color-stone-400);
      --button-border-color: var(--p-color-stone-400);
    }
    &--on-dark {
      --button-text-color: var(--color-text-on);
      --button-border-color: var(--s-color-border-on-dark);
      --button-outline: var(--b-color-white);
      &:active {
        --button-border-color: var(--b-color-neutral-default);
        --button-text-color: var(--b-color-neutral-default);
      }
      #{$btn}__icon {
        --button-icon-color: var(--s-color-icon-on-dark);
      }
      &:disabled, &[disabled] {
        --button-text-color: var(--p-color-stone-400);
        --button-border-color: var(--p-color-stone-400);
      }
    }
  }

  &.loading {
    pointer-events: none;
    cursor: default;
    .anchor-c-btn__text,
    .anchor-c-btn__icon {
      visibility: hidden;
    }
  }
  &--icon-left {
    flex-direction: row-reverse;
  }
}

.anchor-c-btn__text {
  position: relative;
}
.anchor-c-btn__spinner {
  height: var(--button-line-height);
  position: absolute;
}
